import React, { useEffect, useState, useRef } from "react";
import Menu from "@mui/material/Menu";
import {
  Table,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Space,
  Tag,
  Button as Buttons,
  notification,
  Select,
  Typography as Typographys,
  Modal,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  InfoCircleOutlined,
  FileDoneOutlined,
  UndoOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  LockOutlined,
  UsergroupAddOutlined,
  StopOutlined,
  CheckOutlined,
} from "@ant-design/icons";

import { BlobProvider } from "@react-pdf/renderer";
// import MyDocument from "./pdf/membership-invoice.tsx";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import CorporateMemberController from "./Controller/corporate_membership_controller.ts";
import EventController from "./Controller/event_controller.ts";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import CustomSeparator from "../../layouts/AdminLayout/Header/Breadcrumbs.js";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import type { InputRef, TableColumnType } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import { createStyles } from "antd-style";
import { Link } from "react-router-dom";
import CorporateCert from "./pdf/corporate-membership-cert.tsx";

import { pdf } from "@react-pdf/renderer";
import SignatureController from "./Controller/signature_controller.ts";
import CorporateMembershipListExcel from "../../pages/Admin/excel/corporate_membership_list_excel.jsx";
import MembershipCertController from "./Controller/ECert_controller.ts";
import ECert from "./pdf/membership-cert.tsx";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

//imports by  delon on  2025-07-30
import NotificationsIcon from '@mui/icons-material/Notifications';
import axios from "axios";
import InfinityEncryptor from '../../i-plugins/InfinityEncryptor.tsx';

//classes
import Member from '../../i-classes/Member';

const useStyle = createStyles(({ css }) => {
  return {
    customTable: css`
      .ant-table {
        .ant-table-container {
          .ant-table-body,
          .ant-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
          .ant-table-row-expand-icon-cell {
            width: 95px !important;
          }
        }
      }
    `,
  };
});

const { TextArea } = Input;
const { Text } = Typographys;

type NotificationType = "success" | "info" | "warning" | "error";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface ExpandedDataType {
  key: string;
  memberID: string;
  userID: string;
  name: string;
  nationality: string;
  nric: number;
  date_of_birth: string;
  place_of_birth: string;
  race: string;
  gender: string;
  marital_status: string;
  office_tel_no: string;
  fax: string;
  handphone_no: string;
  email: string;
  designation: string;
  nature_of_work: string;
  years_with_company: string;
  academic_qualification: string;
  committee_typeID: string;
  committee_type_label: string;
  account_type: any;
  membership_registrationID: string;
}

interface DataType {
  membership_registrationID: string;
  memberID: string;
  paymentID: string;
  payment_status: any;
  payment_type: string;
  payment_datetime_created: string;
  payment_date_created: string;
  payment_contact_name: string;
  invoice_no: string;
  amounts: string;
  mc_max_term: string;
  datetime_paid: string;
  userID: string;
  company_name: string;
  company_registered_address: string;
  company_number: string;
  date_of_incroporation: number;
  company_correspondence_address: string;
  application_status: string;
  membership_status: any;
  accounts_allotment: number;
  allotment_left: number;
  member_typeID: string;
  member_type_label: string;
  company_email: string;
  name_of_building: string;
  website: string;
  company_telephone_number: string;
  member_names: string;
  total_amount: number;
  amount_paid: number;
  fees: any;
}

type DataIndex = keyof DataType;

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType:
    | "select"
    | "text"
    | "date"
    | "readonly"
    | "number"
    | "accounts_allotment"
    | "select_payment"
    | "payment_remark"
    | "date";
  record: DataType;
  index: number;
  options: any;
}

interface EditableCellPropsSub extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType:
    | "select"
    | "text"
    | "date"
    | "readonly"
    | "number_of_years_with_company"
    | "academic_qualification"
    | "handphone_no"
    | "email"
    | "account_type"
    | "committee_typeID";
  record: ExpandedDataType;
  index: number;
  options: any;
}

const EditableCell: React.FC<React.PropsWithChildren<EditableCellProps>> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  options,
  ...restProps
}) => {
  const minAccAllotment = record?.accounts_allotment;
  let readonly = false;
  let inputNode: any;

  if (inputType === "select") {
    inputNode = (
      <Select>
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  } else if (inputType === "accounts_allotment") {
    readonly = record?.accounts_allotment === null ? true : false; // Set readonly based on record condition
    inputNode = (
      <InputNumber
        disabled={readonly}
        min={minAccAllotment}
        max={10}
        changeOnWheel
      />
    );
  } else if (inputType === "select_payment") {
    if (record.payment_status == null) {
      readonly = true;
    }
    inputNode = (
      <Select
        style={{ marginBottom: 2 }}
        disabled={readonly}
        value={record.payment_status}
      >
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  } else if (inputType === "date") {
    readonly = true;
    inputNode = <Input type="date" />;
  } else {
    readonly = true;
    inputNode = <TextArea autoSize={{ minRows: 2, maxRows: 10 }} />;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: !readonly,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const EditableCellSubCol: React.FC<
  React.PropsWithChildren<EditableCellPropsSub>
> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  options,
  ...restProps
}) => {
  let inputNode: any;
  let required_field = true;

  if (inputType === "select") {
    required_field = false;

    inputNode = (
      <Select>
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  } else if (inputType === "committee_typeID") {
    required_field = false;
    inputNode = (
      <Select
        value={
          record.committee_typeID == null ? "null" : record.committee_typeID
        }
      >
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  } else if (inputType === "academic_qualification") {
    required_field = false;

    inputNode = (
      <Select>
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  } else if (inputType === "date") {
    required_field = false;

    inputNode = <Input type="date" />;
  } else if (inputType === "readonly") {
    required_field = false;
    inputNode = <Input disabled />;
  } else if (inputType === "number_of_years_with_company") {
    required_field = false;

    inputNode = (
      <InputNumber addonBefore="Year(s)" min={1} max={100} changeOnWheel />
    );
  } else if (inputType === "email") {
    required_field = true;
    inputNode = <TextArea autoSize={{ minRows: 2, maxRows: 10 }} />;
  } else if (inputType === "handphone_no") {
    required_field = true;
    inputNode = <TextArea autoSize={{ minRows: 2, maxRows: 10 }} />;
  } else if (inputType === "account_type") {
    required_field = false;

    inputNode = (
      <Select value={record.account_type}>
        {options.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    );
  } else {
    required_field = false;
    inputNode = <TextArea autoSize={{ minRows: 2, maxRows: 10 }} />;
  }
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: required_field,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

// CHECKBOX FOR BASE COLUMN
const CheckboxList = ({ baseColumns, checkedColumns, onChange }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleToggle = (value: Number) => () => {
    const currentIndex = checkedColumns.indexOf(value);
    const newChecked = [...checkedColumns];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    onChange(newChecked); // Call the parent onChange handler
  };

  return (
    <>
      <Button
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        variant="contained"
        sx={{ mb: 3 }}
        style={{ backgroundColor: "#d33333" }}
      >
        Columns
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            // maxHeight: 400,
            width: "20ch",
          },
        }}
      >
        <List
          sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
        >
          {baseColumns.map((value) => {
            const isChecked = checkedColumns.includes(value.dataIndex);
            const labelId = `checkbox-list-label-${value.dataIndex}`;
            return (
              <ListItem key={value.dataIndex} disablePadding>
                <ListItemButton
                  role={undefined}
                  onClick={handleToggle(value.dataIndex)}
                  dense
                >
                  <ListItemIcon>
                    <Checkbox
                      edge="start"
                      checked={isChecked}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ "aria-labelledby": labelId }}
                    />
                  </ListItemIcon>
                  <ListItemText id={labelId} primary={value.title} />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Menu>
    </>
  );
};

const formatDate = (dateString) => {
  const date = new Date(dateString); // Convert to Date object
  return date.toLocaleString("en-US", {
    weekday: "long", // Example: Friday
    year: "numeric", // Example: 2024
    month: "long", // Example: November
    day: "numeric", // Example: 29
    hour: "numeric", // Example: 9
    minute: "numeric", // Example: 30
  });
};

function CorporateMembership() {
  //Get Pending notification count edited by delon on 2025-07-30
  //states
  const [pendingRegistrationsCount, SetPendingRegistrationsCount] = useState({"corporate": 0, "individual": 0, "affiliate-corporate": 0, "affiliate-individual": 0, "associate": 0, "honorary-member": 0});
  
  
  //watchers
  //initialize
  useEffect(() => {
    const encryptor = new InfinityEncryptor('22499', 'MYDIH');
    const formData  = new FormData();
    formData.append("s3cr3t", encryptor.Encrypt('ppkm_14082024_mobile'));
    formData.append("fetchPendingRegistrationsCount", encryptor.Encrypt("true"));

    axios.post("https://www.ppkm.org.my/mobile_backend/scripts/registrationControl.php", formData, { withCredentials: false }).then((res: any) => {
      const decrypted = encryptor.Decrypt(res.data);
      let resObj = {} as any;
      try {
        resObj = JSON.parse(decrypted) as any;
      } catch {
        resObj = decrypted as any;
      }
      console.log(decrypted);
      SetPendingRegistrationsCount(resObj);
    }).catch((err: string) => {
      console.log('fetchPendingRegistrationsCountErr: ' + err);
    });
  }, []);


  // ************************************************************************* SUB COLUMN ************************************************************
  const [editingKeySubCol, setEditingKeySubCol] = useState("");

  const isEditingSubCol = (record: ExpandedDataType) => {
    return String(record.key) === String(editingKeySubCol);
  };
  const editSubCol = (
    record: Partial<ExpandedDataType> & { userID: string }
  ) => {
    form.setFieldsValue({ name: "", age: "", address: "", ...record });
    // Only set editingKey1 if representative_email is not undefined
    if (record?.key) {
      setEditingKeySubCol(record.key);
    }
  };

  const userID = localStorage.getItem("userID");

  const cancelEditSubCol = () => {
    setEditingKeySubCol("");
  };

  const saveSubRow = async (
    key: React.Key,
    membership_registrationID: any,
    userID: any
  ) => {
    try {
      const row = (await form.validateFields()) as ExpandedDataType;

      const newData = [...rows];
      const index = newData.findIndex((item) => key === item.memberID);
      if (index > -1) {

        const payload = {
          membership_registrationID: membership_registrationID,
          userID: userID,
          data: row,
        };

        CorporateMemberController.saveRowSubCol(payload).then((response) => {
          console.log(response);
          if (response?.status === "success") {
            openNotificationWithIcon(
              "success",
              "Your data has been saved successfully!",
              "Success"
            );

            setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
          }
        });

        setEditingKeySubCol("");
      } else {
        // setData(newData);
        setEditingKeySubCol("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);

      errInfo.errorFields.forEach((item) => {
        openNotificationWithIcon("error", item.errors, "Errors");
      });
    }
  };

  const expandColumns = [
    {
      title: "Operation",
      dataIndex: "operation",
      key: "operation",
      width: 160,
      render: (_: any, record: ExpandedDataType) => {
        const editable = isEditingSubCol(record);
        const pathInfo = "/ppkm/admin/member_user_info";
        const stateInfo = { userID: record.userID };
        const fullPathInfo = handleQueryString(pathInfo, stateInfo);

        const pathPassword = "/admin/reset_password";
        const statePassword = { userID: record.userID };
        const fullPathPassword = handleQueryString(pathPassword, statePassword);
        return (
          <>
            {editable ? (
              <Space>
                <Buttons
                  onClick={() =>
                    saveSubRow(
                      record.memberID,
                      record.membership_registrationID,
                      record.userID
                    )
                  }
                  color="default"
                  variant="solid"
                >
                  Save
                </Buttons>
                <Buttons color="default" variant="outlined">
                  <Popconfirm
                    title="Sure to cancel?"
                    onConfirm={cancelEditSubCol}
                  >
                    Cancel
                  </Popconfirm>
                </Buttons>
              </Space>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  <Buttons
                    color="default"
                    variant="solid"
                    icon={<EditOutlined />}
                    disabled={editingKey !== "" || editingKeySubCol !== ""}
                    onClick={() => editSubCol(record)}
                  >
                    Edit
                  </Buttons>
                  <Buttons
                    type="default"
                    style={{ marginBottom: "10px" }}
                    icon={<LockOutlined />}
                  >
                    <Link
                      to={fullPathPassword}
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      Password
                    </Link>
                  </Buttons>
                  <Buttons
                    type="default"
                    style={{ marginBottom: "10px" }}
                    icon={<InfoCircleOutlined />}
                    onClick={() =>
                      window.open(fullPathInfo, "_blank", "noopener,noreferrer")
                    }
                  >
                    Info
                  </Buttons>
                </div>
              </>
            )}
          </>
        );
      },
    },
    {
      title: "Representative Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      editable: true,
    },
    {
      title: "NRIC",
      dataIndex: "nric",
      key: "nric",
      width: 200,
      editable: true,
    },
    {
      title: "H/P",
      dataIndex: "handphone_no",
      key: "handphone_no",
      editable: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
      editable: true,
    },
    {
      title: "Committe Type",
      dataIndex: "committee_typeID",
      key: "committee_typeID",
      width: 200,
      editable: true,
      render: (committee_typeID: any, record: ExpandedDataType) => {
        return (
          <Tag color="geekblue">
            {record.committee_type_label ? record.committee_type_label : "None"}
          </Tag>
        );
      },
    },
    {
      title: "Account Type",
      dataIndex: "account_type",
      key: "account_type",
      width: 200,
      editable: true,
      render: (committee_typeID: any, record: ExpandedDataType) => {
        return Number(record.account_type) === 0 ? (
          <Tag color="blue"> Appointed Rept. Account</Tag>
        ) : Number(record.account_type) === 1 ? (
          <Tag color="purple"> Alternate Rept. Account</Tag>
        ) : (
          <Tag color="magenta"> Others Account</Tag>
        );
      },
    }
  ];

  const [committeeTypeOptions, setCommitteeType] = useState([]);
  const [memberTypeFilter, setMemberTypeFilter] = useState([]);

  useEffect(() => {
    CorporateMemberController.getCommitteeType().then((response) => {
      const committeeTypeOptions = response.map((item) => ({
        label: item.label,
        value: item.committee_typeID,
      }));

      // Add a new row at the end of the array
      committeeTypeOptions.push({
        label: "None", // Customize as needed
        value: "null", // Provide the appropriate value
      });
      setCommitteeType(committeeTypeOptions);
    });

    EventController.getMemberType().then((response) => {
      const filters = response?.map((item) => ({
        text: item.label,
        value: item.member_typeID,
      }));
      setMemberTypeFilter(filters);
    });
  }, []);

  const expandedRowRender = (record: DataType) => {
    // Convert record.membership_registrationID to number if it's a string
    const memberID = String(record.memberID);
    const membership_registrationID = String(record.membership_registrationID);
    // Check if any item in rows1 has the same membership_registrationID as the current record
    const matchingRow = subRows.find(
      (item) => String(item.memberID) === memberID
    );

    if (matchingRow) {
      const expandDataSource = subRows
        .filter((innerItem) => {
          return (
            innerItem.membership_registrationID === membership_registrationID
          ); // Return the comparison result
        })
        .map<ExpandedDataType>((item) => ({
          key: item.userID,
          memberID: item.memberID,
          userID: item.userID,
          membership_registrationID: item.membership_registrationID,
          name: item.name,
          nationality: item.nationality,
          nric: item.nric,
          date_of_birth: item.date_of_birth,
          place_of_birth: item.place_of_birth,
          race: item.race,
          gender: item.gender,
          marital_status: item.marital_status,
          office_tel_no: item.office_tel_no,
          fax: item.fax,
          handphone_no: item.handphone_no,
          email: item.email,
          designation: item.designation,
          nature_of_work: item.nature_of_work,
          years_with_company: item.years_with_company,
          academic_qualification: item.academic_qualification,
          committee_typeID: item.committee_typeID,
          committee_type_label: item.committee_type_label,
          account_type: item.account_type,
        }));

      const academicQualificationOptions = [
        { label: "None", value: 0 },
        { label: "Certificate", value: 1 },
        { label: "Diploma", value: 2 },
        { label: "Advanced Diploma", value: 3 },
        { label: "Bachelor", value: 4 },
        { label: "Masters", value: 5 },
        { label: "Doctoral", value: 6 },
      ];

      const accountTypeOptions = [
        { label: "Appointed Rept.", value: 0 },
        { label: "Alternate Rept.", value: 1 },
        { label: "Others", value: 2 },
      ];

      const mergedExpandColumns = expandColumns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record: ExpandedDataType) => ({
            record,
            inputType:
              col.dataIndex === "years_with_company"
                ? "number_of_years_with_company"
                : col.dataIndex === "dob"
                ? "date"
                : col.dataIndex === "userID"
                ? "readonly"
                : col.dataIndex === "email"
                ? "email"
                : col.dataIndex === "handphone_no"
                ? "handphone_no"
                : col.dataIndex === "account_type"
                ? "account_type"
                : col.dataIndex === "membership_registrationID"
                ? "readonly"
                : col.dataIndex === "academic_qualification"
                ? "academic_qualification"
                : col.dataIndex === "committee_typeID"
                ? "committee_typeID"
                : "text", // Update to set 'date' for date columns
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditingSubCol(record),
            options:
              col.dataIndex === "committee_typeID"
                ? committeeTypeOptions
                : col.dataIndex === "academic_qualification"
                ? academicQualificationOptions
                : col.dataIndex === "account_type"
                ? accountTypeOptions
                : undefined,
          }),
        };
      });
      return (
        <Form form={form} component={false}>
          <Table<ExpandedDataType>
            components={{
              body: { cell: EditableCellSubCol },
            }}
            columns={mergedExpandColumns}
            dataSource={expandDataSource}
            pagination={false}
            scroll={{ x: "200vh" }}
            // rowKey="membership_registrationID" // Set your custom key here
          />
        </Form>
      );
    } else {
      const expandDataSource = subRowsRepresentatives
        .filter((innerItem) => {
          return (
            innerItem.membership_registrationID === membership_registrationID
          ); // Return the comparison result
        })
        .map<ExpandedDataType>((item) => {
          return {
            key: item.key,
            memberID: item.memberID,
            userID: item.userID,
            membership_registrationID: item.membership_registrationID,
            name: item.name,
            nationality: item.nationality,
            nric: item.nric,
            date_of_birth: item.date_of_birth,
            place_of_birth: item.place_of_birth,
            race: item.race,
            gender: item.gender,
            marital_status: item.marital_status,
            office_tel_no: item.office_tel_no,
            fax: item.fax,
            handphone_no: item.handphone_no,
            email: item.email,
            designation: item.designation,
            nature_of_work: item.nature_of_work,
            years_with_company: item.years_with_company,
            academic_qualification: item.academic_qualification,
            committee_typeID: item.committee_typeID,
            committee_type_label: item.committee_type_label,
            type: item.type,
            account_type: item.account_type,
          };
        });

      const academicQualificationOptions = [
        { label: "None", value: 0 },
        { label: "Certificate", value: 1 },
        { label: "Diploma", value: 2 },
        { label: "Advanced Diploma", value: 3 },
        { label: "Bachelor", value: 4 },
        { label: "Masters", value: 5 },
        { label: "Doctoral", value: 6 },
      ];

      const accountTypeOptions = [
        { label: "Appointed Rept.", value: 0 },
        { label: "Alternate Rept.", value: 1 },
        { label: "Others", value: 2 },
      ];

      const mergedExpandColumns = expandColumns.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record: ExpandedDataType) => ({
            record,
            inputType:
              col.dataIndex === "years_with_company"
                ? "number_of_years_with_company"
                : col.dataIndex === "dob"
                ? "date"
                : col.dataIndex === "committee_typeID"
                ? "readonly"
                : col.dataIndex === "userID"
                ? "readonly"
                : col.dataIndex === "email"
                ? "email"
                : col.dataIndex === "handphone_no"
                ? "handphone_no"
                : col.dataIndex === "account_type"
                ? "account_type"
                : col.dataIndex === "membership_registrationID"
                ? "readonly"
                : col.dataIndex === "academic_qualification"
                ? "academic_qualification"
                : col.dataIndex === "committee_typeID"
                ? "committee_typeID"
                : "text", // Update to set 'date' for date columns
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditingSubCol(record),
            options:
              col.dataIndex === "committee_typeID"
                ? committeeTypeOptions
                : col.dataIndex === "academic_qualification"
                ? academicQualificationOptions
                : col.dataIndex === "account_type"
                ? accountTypeOptions
                : undefined,
          }),
        };
      });
      return (
        <Form form={form} component={false}>
          <Table<ExpandedDataType>
            components={{
              body: { cell: EditableCellSubCol },
            }}
            columns={mergedExpandColumns}
            dataSource={expandDataSource}
            pagination={false}
            // scroll={{ x: "200vh" }}
            // rowKey="membership_registrationID" // Set your custom key here
          />
        </Form>
      );
    }
  };
  // *********************************************** END OF SUB COLUMN ***************************************************************************************************

  const [rows, setRows] = useState<any[]>([]);
  const [subRows, setSubRows] = useState<any[]>([]);
  const [subRowsRepresentatives, setSubRowsRepresentatives] = useState<any[]>(
    []
  );
  // const [data, setData] = useState<DataType[]>(rows);
  const [shouldRefetchData, setShouldRefetchData] = useState(false);

  useEffect(() => {
    CorporateMemberController.getData().then((response) => {
      console.log(response);
      const dynamicRows = response.main_data.map((item: any, index: number) => {
        const date = item.payment_datetime_created;
        const dateOnly = date ? date.split(" ")[0] : ""; // Outputs '2024-10-07'
        return {
          key: index,
          application_status: item.application_status,
          membership_status: item.membership_status,
          membership_registrationID: item.membership_registrationID,
          memberID: item.memberID,
          member_typeID: item.member_typeID,
          member_type_label: item.member_type_label,
          paymentID: item.paymentID,
          payment_status: item.payment_status,
          mc_max_term: item.mc_max_term,
          payment_type: item.payment_type,
          payment_datetime_created: item.payment_datetime_created,
          payment_date_created: dateOnly,
          payment_contact_name: item.payment_contact_name,
          fees: item.fees,
          total_amount: item.total_amount
            ? item.total_amount.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : item.total_amount,
          invoice_no: item.invoice_no,
          amounts: item.amounts,
          amount_paid: item.amount_paid
            ? item.amount_paid.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : item.amount_paid,
          datetime_paid: item.datetime_paid,
          company_name: item.company_name,
          company_registered_address: item.company_registered_address,
          company_number: item.company_number,
          date_of_incorporation: item.date_of_incorporation,
          company_correspondence_address: item.company_correspondence_address,
          name_of_building: item.name_of_building,
          website: item.website,
          company_telephone_number: item.company_telephone_number,
          company_fax: item.company_fax,
          company_email: item.company_email,
          gross_built_up_area: item.gross_built_up_area,
          nett_lettable_area: item.nett_lettable_area,
          accounts_allotment: item.accounts_allotment,
          allotment_left: item.allotment_left,
          member_names: item.member_names
        };
      });

      const allSubRows = response.member_data.map((item) => {
        return item.map((innerItem) => ({
          memberID: innerItem.memberID,
          membership_registrationID: innerItem.membership_registrationID,
          userID: innerItem.userID,
          name: innerItem.name,
          nationality: innerItem.nationality,
          nric: innerItem.nric,
          date_of_birth: innerItem.date_of_birth,
          place_of_birth: innerItem.place_of_birth,
          race: innerItem.race,
          gender: innerItem.gender,
          marital_status: innerItem.marital_status,
          office_tel_no: innerItem.office_tel_no,
          fax: innerItem.fax,
          handphone_no: innerItem.handphone_no,
          email: innerItem.email,
          designation: innerItem.designation,
          nature_of_work: innerItem.nature_of_work,
          years_with_company: innerItem.years_with_company,
          academic_qualification: innerItem.academic_qualification,

          committee_typeID: innerItem.committee_typeID,
          committee_type_label: innerItem.committee_type_label,
          account_type: innerItem.type,
        }));
      });

      let representativesRow = [];
      representativesRow = response.representative_data.map((item) => {
        return {
          memberID: item.memberID,
          membership_registrationID: item.membership_registrationID,
          key: item.key,
          userID: item.userID,
          name: item.name,
          nationality: item.nationality,
          nric: item.nric,
          date_of_birth: item.date_of_birth,
          place_of_birth: item.place_of_birth,
          race: item.race,
          gender: item.gender,
          marital_status: item.marital_status,
          office_tel_no: item.office_tel_no,
          fax: item.appointed_representative_fax,
          handphone_no: item.handphone_no,
          email: item.email,
          designation: item.designation,
          nature_of_work: item.nature_of_work,
          years_with_company: item.years_with_company,
          academic_qualification: item.academic_qualification,
          paymentID: item.paymentID,
          payment_status: item.payment_status,
          payment_remark: item.payment_remark,
          committee_typeID: item.committee_typeID,
          committee_type_label: item.committee_type_label,
          account_type: item.type,
        };
      });
      // main rows data (member which is company) from members table
      setRows(Array.from(dynamicRows));

      const flattenedSubRows = allSubRows.flat();
      // Member Users (approved users) from member users table
      setSubRows(flattenedSubRows);

      // Representatives only from membership registration table
      setSubRowsRepresentatives(representativesRow);
    });
  }, [shouldRefetchData]);

  // Update data whenever rows changes
  useEffect(() => {
    // setData(rows);
  }, [rows, subRows]);

  //test
  useEffect(() => {
    console.log('CheckRows: ' + JSON.stringify(rows));
  }, [rows]);

  // **************************** MODAL TO INPUT MEMBER ID *****************************************************
  const [isModalMemberIDOpen, setIsModalMemberIDOpen] = useState(false);
  const [membership_registrationID, setMembershipRegistrationID] = useState("");
  const [membershipNumber, setMembershipNumber] = useState("");

  const showModalMemberID = (membership_registrationID) => {
    setIsModalMemberIDOpen(true);
    setMembershipRegistrationID(membership_registrationID);
  };

  // *************************************************************************************************************
  // **************************** MODAL TO INPUT PAYMENT *****************************************************
  const [isModalPaymentOpen, setIsModalPaymentOpen] = useState(false);
  const [memberID, setMemberID] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [paymentReference, setPaymentReference] = useState("");

  const showModalPayment = (membership_registrationID, memberID) => {
    setIsModalPaymentOpen(true);
    setMembershipRegistrationID(membership_registrationID);
    setMemberID(memberID);
  };

  // *************************************************************************************************************

  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [editingKey, setEditingKey] = useState("");

  const isEditing = (record: DataType) => {
    return String(record.membership_registrationID) === String(editingKey);
  };

  // Number(record.membership_registrationID) === Number(editingKey);
  const edit = (
    record: Partial<DataType> & { membership_registrationID: string }
  ) => {
    form.setFieldsValue({ name: "", age: "", address: "", ...record });
    setEditingKey(record.membership_registrationID);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const delete_record = (rowId: any, userID) => {
    const payload = new FormData();
    payload.append("ID", rowId);
    payload.append("userID", userID);
    CorporateMemberController.deleteRow(payload).then((response) => {
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Your data has been deleted successfully!",
          "Success"
        );

        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      }
    });
  };

  const delete_member = (rowId: any, memberID: any, paymentID: any, userID) => {
    const payload = new FormData();
    payload.append("ID", rowId);
    payload.append("memberID", memberID);
    payload.append("paymentID", paymentID);
    payload.append("userID", userID);

    // console.log(rowId)
    // console.log(memberID)
    // console.log(paymentID)
    CorporateMemberController.deleteMember(payload).then((response) => {
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Your data has been deleted successfully!",
          "Success"
        );

        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      }
    });
  };

  const deactivateMember = (rowId: any, userID) => {
    const payload = new FormData();
    payload.append("memberID", rowId);
    payload.append("userID", userID);
    CorporateMemberController.deactivateMembership(payload).then((response) => {
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Membership has been deactivated successfully!",
          "Success"
        );

        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      }
    });
  };

  const reactivateMember = (rowId: any, userID) => {
    const payload = new FormData();
    payload.append("memberID", rowId);
    payload.append("userID", userID);
    CorporateMemberController.reactivateMembership(payload).then((response) => {
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Membership has been reactivated successfully!",
          "Success"
        );

        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
      }
    });
  };

  const save = async (key: React.Key, userID) => {
    try {
      const row = (await form.validateFields()) as DataType;
      const newData = [...rows];
      const index = newData.findIndex(
        (item) => key === item.membership_registrationID
      );
      const membership_registrationID =
        newData[index].membership_registrationID;
      const application_status = newData[index].application_status;
      const memberID = newData[index].memberID;
      const paymentID = newData[index].paymentID;

      if (index > -1) {
        // set rows here
        const payload = {
          ID: membership_registrationID,
          membership_status: application_status,
          memberID: memberID,
          paymentID: paymentID,
          data: row,
          userID: userID,
        };

        CorporateMemberController.saveRow(payload).then((response) => {
          console.log(response);
          if (response?.status === "success") {
            setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect

            openNotificationWithIcon(
              "success",
              "Your data has been saved successfully!",
              "Success"
            );
          }
        });

        setEditingKey("");
      } else {
        // setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const generatePdfBlob = async (dataItem: any) => {
    const response = await SignatureController.getSignatures(); // Fetch latest signatures
    const presidentData = response.find(
      (data) => Number(data.designation) === 0
    );
    const secretariatData = response.find(
      (data) => Number(data.designation) === 1
    );

    const blob = await pdf(
      <CorporateCert
        data={dataItem}
        presidentData={presidentData}
        secretariatData={secretariatData}
      />
    ).toBlob();

    return blob;
  };

  const blobToBase64 = (blob: Blob) => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        if (typeof result === "string") {
          resolve(result.split(",")[1]); // Extract Base64 string
        } else {
          reject(new Error("Failed to read file"));
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const handleApprove = async (userID) => {
    const membershipRegistrationID = membership_registrationID;
    console.log(paymentAmount);
    console.log(paymentReference);

    try {
      const newData = [...rows];
      const index = newData.findIndex(
        (item) =>
          String(membershipRegistrationID) ===
          String(item.membership_registrationID)
      );

      const pdfBlob = await generatePdfBlob(newData[index]);
      const pdfBase64 = await blobToBase64(pdfBlob);

      if (index > -1) {
        const payload = new FormData();
        payload.append("membership_registrationID", membershipRegistrationID);
        payload.append("memberID", membershipNumber);
        payload.append("userID", userID);

        if (typeof pdfBase64 === "string") {
          payload.append("pdfCertificateBase64", pdfBase64);
        } else {
          console.error("pdfBase64 is not a string");
        }

        payload.append("paid_amount", paymentAmount);
        payload.append("payment_reference", paymentReference);

        CorporateMemberController.approveMembership(payload).then(
          (response) => {
            //edited by delon on 2025-07-29
            if(!JSON.stringify(response).includes('_false')) {
              form.resetFields(); // Clear input after submitting
              setIsModalMemberIDOpen(false); // Close modal after submit
              openNotificationWithIcon(
                "success",
                "Application has been approved successfully!",
                "Success"
              );

              setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
            }  else {
              if(JSON.stringify(response).includes('registerMemberErr')) {
                openNotificationWithIcon("error", "Fail to create new membership record, please check if the membership no is already assigned to an existing member.", "Error");
                console.log(JSON.stringify(response));
              } else if(JSON.stringify(response).includes('createPaymentAndGenerateMembershipContractErr')) {
                openNotificationWithIcon("error", "Fail to create payment and membership contract record, please contact support.", "Error");
              }
            }
            /* if (response?.status === "success") {
              form.resetFields(); // Clear input after submitting
              setIsModalMemberIDOpen(false); // Close modal after submit
              openNotificationWithIcon(
                "success",
                "Application has been approved successfully!",
                "Success"
              );

              setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
            } else {
              const message = response?.status || "";

              openNotificationWithIcon("error", message, "Error");
            }*/
          }
        );
      }
    } catch (errInfo) {}
  };

  const handleActivateMembership = async (userID) => {
    const payload = new FormData();
    payload.append("memberID", memberID);
    payload.append("userID", userID);
    payload.append("membership_registrationID", membership_registrationID);
    payload.append("paid_amount", paymentAmount);
    payload.append("payment_reference", paymentReference);

    CorporateMemberController.renewMembership(payload).then((response) => {
      console.log(response);
      if (response?.status === "success") {
        setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
        setIsModalPaymentOpen(false);
        form.resetFields(); // Clear input after submitting
        openNotificationWithIcon(
          "success",
          "Membership contract renewal has been created successfully!",
          "Success"
        );
      }
    });
  };

  const handleUndoApprove = async (key: React.Key, paymentID: any, userID) => {
    try {
      const newData = [...rows];
      const index = newData.findIndex(
        (item) => key === item.membership_registrationID
      );
      const membership_registrationID =
        newData[index].membership_registrationID;

      const memberID = newData[index].memberID;

      if (index > -1) {
        const payload = {
          ID: membership_registrationID,
          paymentID: paymentID,
          memberID: memberID,
          userID: userID,
        };

        CorporateMemberController.removeMembership(payload).then((response) => {
          if (response?.status === "success") {
            openNotificationWithIcon(
              "success",
              "Application has been unapproved successfully!",
              "Success"
            );

            setShouldRefetchData((prev) => !prev); // Toggle to re-trigger useEffect
          }
        });
      }
    } catch (errInfo) {}
  };

  const handleQueryString = (path: string, state: Record<string, string>) => {
    const queryString = new URLSearchParams(state).toString();
    return `${path}?${queryString}`;
  };

  // **************************** SEARCH FILTER ANTD TABLE *****************************************************
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Buttons
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Buttons>
          <Buttons
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Buttons>
          <Buttons
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Buttons>
          <Buttons
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Buttons>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes((value as string).toLowerCase())
        : false,
    onFilterDropdownOpenChange: (open) => {
      if (open) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  // ************************************************************************************************************

  const openPdfPreview = (url) => {
    // Open the PDF in a new tab
    const newWindow = window.open(url, "_blank");
    if (!newWindow) {
      alert("Please allow popups for this website to preview the PDF.");
    }
  };

  const handleGenerateCert = async (memberID: string) => {
    try {
      const payload = new FormData();
      payload.append("memberID", memberID);

      const data = await MembershipCertController.getMembershipCertInfo(
        payload
      );
      const signatures = await SignatureController.getSignatures();

      const presidentData = signatures.find(
        (sig) => Number(sig.designation) === 0
      );
      const secretariatData = signatures.find(
        (sig) => Number(sig.designation) === 1
      );

      if (!presidentData?.signature_url || !secretariatData?.signature_url) {
        alert(
          "Cannot generate certificate.\nMissing president or secretary signature."
        );
        return;
      }

      const blob = await pdf(
        <ECert
          data={data}
          presidentData={presidentData}
          secretariatData={secretariatData}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");

      // Optional: If you want to revoke the URL after opening it
      // setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (err) {
      console.error("Error generating PDF:", err);
      alert("Failed to generate e-certificate.\nPlease try again.");
    }
  };

  const baseColumns = [
    {
      title: "Operation",
      dataIndex: "operation",
      width: 180,
      render: (_: any, record: DataType) => {
        const editable = isEditing(record);

        const path = "/admin/corporate_info";
        const state = {
          membership_registrationID: record.membership_registrationID,
        };
        const fullPath = handleQueryString(path, state);

        const invoice_notes = record.fees.map((item: any, index: number) => {
          return item.invoice_notes;
        });

        return (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "90%",
              }}
            >
              <Buttons
                type="default"
                style={{ marginBottom: "10px" }}
                icon={<InfoCircleOutlined />}
              >
                <Link
                  to={fullPath}
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  Info
                </Link>
              </Buttons>

              {editable ? (
                <>
                  <Buttons
                    onClick={() =>
                      save(record.membership_registrationID, userID)
                    }
                    color="default"
                    variant="solid"
                    style={{ marginBottom: "10px" }}
                  >
                    Save
                  </Buttons>

                  <Buttons color="default" variant="outlined">
                    <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                      Cancel
                    </Popconfirm>
                  </Buttons>
                </>
              ) : (
                <>
                  <Buttons
                    color="default"
                    variant="solid"
                    icon={<EditOutlined />}
                    disabled={editingKey !== "" || editingKeySubCol !== ""}
                    onClick={() => edit(record)}
                    style={{ marginBottom: "10px" }}
                  >
                    Edit
                  </Buttons>

                  {Number(record.application_status) === 0 && (
                    <Popconfirm
                      title="Sure to approve?"
                      onConfirm={() =>
                        showModalMemberID(record.membership_registrationID)
                      } // Ensure this is a function call
                      okText="Yes"
                      cancelText="No"
                    >
                      <Buttons
                        color="default"
                        variant="outlined"
                        disabled={editingKey !== "" || editingKeySubCol !== ""}
                        style={{ marginBottom: "10px" }}
                      >
                        <FileDoneOutlined /> Approve
                      </Buttons>
                    </Popconfirm>
                  )}

                  {Number(record.payment_status) === 0 &&
                    Number(record.application_status) === 1 && (
                      <>
                        <Buttons
                          color="default"
                          variant="outlined"
                          disabled={editingKey !== ""}
                          style={{ marginBottom: "10px" }}
                        >
                          <UndoOutlined />

                          <Popconfirm
                            title="Sure to approve?"
                            onConfirm={() =>
                              handleUndoApprove(
                                record.membership_registrationID,
                                record.paymentID,
                                userID
                              )
                            }
                          >
                            Undo Approve
                          </Popconfirm>
                        </Buttons>
                      </>
                    )}

                  {Number(record.application_status) === 0 && (
                    <Buttons
                      type="primary"
                      style={{ marginBottom: "10px" }}
                      danger
                      icon={<DeleteOutlined />}
                      disabled={editingKey !== "" || editingKeySubCol !== ""}
                    >
                      <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() =>
                          delete_record(
                            record.membership_registrationID,
                            userID
                          )
                        }
                      >
                        Delete
                      </Popconfirm>
                    </Buttons>
                  )}

                  {Number(record.application_status) === 1 && (
                    <>
                      <Buttons
                        type="default"
                        color="primary"
                        style={{ marginBottom: "10px" }}
                        icon={<WorkspacePremiumIcon />}
                        onClick={() => handleGenerateCert(record.memberID)}
                      >
                        E-Certificate
                      </Buttons>
                      <Buttons
                        type="primary"
                        style={{ marginBottom: "10px" }}
                        danger
                        icon={<DeleteOutlined />}
                        disabled={editingKey !== "" || editingKeySubCol !== ""}
                      >
                        <Popconfirm
                          title="Sure to delete?"
                          onConfirm={() =>
                            delete_member(
                              record.membership_registrationID,
                              record.memberID,
                              record.paymentID,
                              userID
                            )
                          }
                        >
                          Delete Member
                        </Popconfirm>
                      </Buttons>
                    </>
                  )}

                  {record.mc_max_term &&
                    new Date(record.mc_max_term) < new Date() &&
                    Number(record.payment_status) === 1 && (
                      <Buttons
                        color="default"
                        variant="outlined"
                        disabled={editingKey !== "" || editingKeySubCol !== ""}
                        style={{
                          marginBottom: "10px",
                          backgroundColor: "#4CAF50", // Custom background color
                          color: "#FFFFFF", // Custom text color
                          borderColor: "#4CAF50", // Custom border color
                        }}
                      >
                        <Popconfirm
                          title="Sure to renew membership?"
                          onConfirm={() =>
                            showModalPayment(
                              record.membership_registrationID,
                              record.memberID
                            )
                          }
                        >
                          <CheckCircleOutlined /> Renew
                        </Popconfirm>
                      </Buttons>
                    )}

                  {record.memberID &&
                    Number(record.membership_status) === 1 && (
                      <Buttons
                        type="primary"
                        style={{ marginBottom: "10px" }}
                        danger
                        icon={<StopOutlined />}
                        disabled={editingKey !== "" || editingKeySubCol !== ""}
                      >
                        <Popconfirm
                          title="Sure to suspend membership?"
                          onConfirm={() =>
                            deactivateMember(record.memberID, userID)
                          }
                        >
                          Suspend
                        </Popconfirm>
                      </Buttons>
                    )}

                  {record.memberID &&
                    Number(record.membership_status) === 0 && (
                      <Buttons
                        type="primary"
                        style={{
                          marginBottom: "10px",
                          backgroundColor: "#4CAF50", // Custom background color
                          color: "#FFFFFF", // Custom text color
                          borderColor: "#4CAF50", // Custom border color
                        }}
                        danger
                        icon={<CheckOutlined />}
                        disabled={editingKey !== "" || editingKeySubCol !== ""}
                      >
                        <Popconfirm
                          title="Sure to activate membership?"
                          onConfirm={() =>
                            reactivateMember(record.memberID, userID)
                          }
                        >
                          Unsuspend
                        </Popconfirm>
                      </Buttons>
                    )}
                </>
              )}
            </div>
          </>
        );
      },
    },
    {
      title: "",
      dataIndex: "expand",
      key: "expand",
      width: 150, // Set a custom width for the expandable column
    },
    {
      title: "Registration ID",
      dataIndex: "membership_registrationID",
      key: "membership_registrationID",
    },
    {
      title: "Membership No.",
      dataIndex: "memberID",
      key: "memberID",
      editable: true,
      ...getColumnSearchProps("memberID"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Status",
      dataIndex: "application_status",
      key: "application_status",
      width: 200,
      render: (status: any, record: DataType) => {
        if (Number(status) === 1) {
          // Application is approved
          return (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <Text>
                  Application: <Tag color="blue">Approved</Tag>
                </Text>
                <Text>
                  Membership:
                  {Number(record.membership_status) === 1 ? (
                    <Tag color="green">Active</Tag>
                  ) : (
                    <Tag color="red">Inactive</Tag>
                  )}
                </Text>
              </div>
            </>
          );
        } else {
          // Application is pending
          return (
            <>
              <Text>
                Application: <Tag color="orange">Pending</Tag>{" "}
              </Text>{" "}
              <Text>
                Membership: <Tag color="red">Pending</Tag>{" "}
              </Text>
            </>
          );
        }
      },
      filters: [
        { text: "Approved", value: 1 },
        { text: "Pending", value: 0 },
      ],
      onFilter: (value: any, record: DataType) =>
        record.application_status === value,
    },
    {
      title: "Payment",
      dataIndex: "payment_status",
      key: "payment_status",
      width: 200,
      render: (payment_status: any, record: DataType) => {
        let payment_issued = record.paymentID;
        let max_term_color = "";

        if (new Date(record.mc_max_term) < new Date()) {
          max_term_color = "red";
        } else {
          max_term_color = "green";
        }

        if (payment_issued && Number(payment_status) === 1) {
          return (
            <Space direction="vertical" size="small">
              <Text>
                Type: <Tag color="green">{record.payment_type}</Tag>
              </Text>
              <Text>
                Max Term:{" "}
                <Tag color={max_term_color}>
                  {record.mc_max_term ? record.mc_max_term : "none"}
                </Tag>
              </Text>
              <Text>
                Status: <Tag color="green">Paid</Tag>
              </Text>
              {/* <Text>
                Total Amount: <Tag color="red">{record.total_amount}</Tag>
              </Text> */}
              {/* <Text>
                Amount Paid:{" "}
                {record.amount_paid ? (
                  <Tag color="red">RM {record.amount_paid}</Tag>
                ) : (
                  "-"
                )}
              </Text> */}
              {/* <Text>
                Date Paid:{" "}
                <Tag color="#87d068">
                  {record.datetime_paid
                    ? formatDate(record.datetime_paid)
                    : "-"}
                </Tag>
              </Text> */}
            </Space>
          );
        } else if (Number(payment_status) === 0) {
          return (
            <>
              <Space direction="vertical" size="small">
                <Text>
                  Type: <Tag color="green">{record.payment_type}</Tag>
                </Text>
                <Text>
                  Max Term:{" "}
                  <Tag color={max_term_color}>
                    {" "}
                    {record.mc_max_term ? record.mc_max_term : "none"}
                  </Tag>
                </Text>
                <Text>
                  Status: <Tag color="red">Pending</Tag>
                </Text>
                {/* <Text>
                  Amount: <Tag color="red">{record.total_amount}</Tag>
                </Text> */}
              </Space>
            </>
          );
        } else if (Number(payment_status) === 2) {
          return (
            <>
              <Space direction="vertical" size="small">
                <Text>
                  Type: <Tag color="green">{record.payment_type}</Tag>
                </Text>
                <Text>
                  Max Term:{" "}
                  <Tag color={max_term_color}>
                    {" "}
                    {record.mc_max_term ? record.mc_max_term : "none"}
                  </Tag>
                </Text>
                <Text>
                  Status: <Tag color="red">Unpaid</Tag>
                </Text>
                {/* <Text>
                  Amount: <Tag color="red">{record.total_amount}</Tag>
                </Text> */}
              </Space>
            </>
          );
        } else {
          return (
            <>
              <Text>
                <Tag color="geekblue">No payment issued yet</Tag>
              </Text>
            </>
          );
        }
      },
      editable: true,
      filters: [
        { text: "Paid", value: 1 },
        { text: "Pending", value: 0 },
        { text: "Unpaid", value: 2 },
      ],
      onFilter: (value: any, record: DataType) => {
        if(
          (value == 0 && record.payment_status ==  null)
          || record.payment_status === value
        )
          return true;
        else
          return false;
      }
    },
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      editable: true,
      width: 200,
      ...getColumnSearchProps("company_name"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Member Names",
      dataIndex: "member_names",
      key: "member_names",
      width: 200,
      ...getColumnSearchProps("member_names"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Company Registration Address",
      dataIndex: "company_registered_address",
      key: "company_registered_address",
      editable: true,
      width: 300,
      ...getColumnSearchProps("company_registered_address"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Company Number",
      dataIndex: "company_number",
      key: "company_number",
      editable: true,
      width: 200,
      ...getColumnSearchProps("company_number"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Date Of Incorporation",
      dataIndex: "date_of_incorporation",
      key: "date_of_incorporation",
      editable: true,
      width: 200,
    },
    {
      title: "Company Correspondence Address",
      dataIndex: "company_correspondence_address",
      key: "company_correspondence_address",
      editable: true,
      width: 300,
      ...getColumnSearchProps("company_correspondence_address"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Name of Building",
      dataIndex: "name_of_building",
      key: "name_of_building",
      editable: true,
      width: 200,
      ...getColumnSearchProps("name_of_building"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Website",
      dataIndex: "website",
      key: "website",
      editable: true,
      width: 200,
      ...getColumnSearchProps("website"), //IMPLEMENT SEARCH FILTER
    },
    {
      title: "Telephone No.",
      dataIndex: "company_telephone_number",
      key: "company_telephone_number",
      editable: true,
      width: 200,
      ...getColumnSearchProps("company_telephone_number"),
    },
    {
      title: "Email",
      dataIndex: "company_email",
      key: "company_email",
      editable: true,
      width: 200,
      ...getColumnSearchProps("company_email"),
    },
    {
      title: "Gross Built Up Area",
      dataIndex: "gross_built_up_area",
      key: "gross_built_up_area",
      width: 200,
      editable: true,
    },
    {
      title: "Net Lettable Area",
      dataIndex: "nett_lettable_area",
      key: "nett_lettable_area",
      width: 200,
      editable: true,
    },
    {
      title: "Accounts Allotment",
      dataIndex: "accounts_allotment",
      key: "accounts_allotment",
      editable: true,
      width: 150,
      render: (_: any, record: DataType) => {
        const path = "/ppkm/admin/add_corporate_member";
        const state = { memberID: record.memberID };
        const fullPath = handleQueryString(path, state);

        return record.accounts_allotment ? (
          <div>
            <Text style={{ display: "block" }}>
              Allotment: <Tag color="green">{record.accounts_allotment}</Tag>
            </Text>
            <Text style={{ display: "block" }}>
              Remaining:{" "}
              {Number(record.allotment_left) >= 1 ? (
                <Tag color="green">{record.allotment_left}</Tag>
              ) : (
                <Tag color="red">{record.allotment_left}</Tag>
              )}
            </Text>

            {Number(record.allotment_left) >= 1 && (
              <Buttons
                variant="solid"
                color="danger"
                style={{ marginTop: "10px" }}
                icon={<UsergroupAddOutlined />}
                onClick={() => (window.location.href = fullPath)}
              >
                Add Member
              </Buttons>
            )}
          </div>
        ) : (
          <></>
        );
      },
    }
  ];

  const onSelectChange = (
    newSelectedRowKeys: React.Key[],
    selectedRows: DataType[]
  ) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);

    // call api here
  };

  const [checkedColumns, setCheckedColumns] = useState([
    "operation",
    "memberID",
    "application_status",
    "payment_status",
    "company_name",
    "company_email",
    "name_of_building",
    "accounts_allotment",
    "member_names",
    "e_invoice_pin"
  ]);

  const onChange = (checkedValues) => {
    setCheckedColumns(checkedValues);
  };

  const statusOptions = [
    { label: "Approve", value: "1" },
    { label: "Pending", value: "0" },
  ];

  const paymentStatusOptions = [
    { label: "Pending", value: 0 },
    { label: "Paid", value: 1 },
    { label: "Unpaid", value: 2 },
  ];

  // Create mergedColumns directly using baseColumns
  const mergedColumns = baseColumns
    .filter(
      (col) =>
        typeof col.dataIndex === "string" &&
        checkedColumns.includes(col.dataIndex)
    )
    .map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record: DataType) => {
          const columnTitle =
            typeof col.title === "string" ? col.title : String(col.title);
          const columnDataIndex =
            typeof col.dataIndex === "string"
              ? col.dataIndex
              : String(col.dataIndex);

          return {
            record,
            inputType:
              columnDataIndex === "application_status"
                ? "select"
                : columnDataIndex === "payment_status"
                ? "select_payment"
                : columnDataIndex === "payment_remark"
                ? "payment_remark"
                : columnDataIndex === "accounts_allotment"
                ? "accounts_allotment"
                : columnDataIndex === "date_of_incorporation"
                ? "date"
                : "text",
            dataIndex: columnDataIndex,
            title: columnTitle,
            editing: isEditing(record),
            options:
              col.dataIndex === "application_status"
                ? statusOptions
                : col.dataIndex === "payment_status"
                ? paymentStatusOptions
                : undefined,
          };
        },
      };
    });
  //END OF BASE COLUMN
  // ______________________________________________________________________________________________________________________________________

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (
    type: NotificationType,
    desc: String,
    message: String
  ) => {
    api[type]({
      message: message,
      description: desc,
    });
  };

  // const handleExpand = () => {
  // };

  const { styles } = useStyle();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#e8e8e8",
          height: "100%", // scroll y for page
          minHeight: "150vh" /* scroll y for page */,
          width: "100vw", // Full viewport width
          overflow: "hidden", // Ensure no overflow from the Box itself
        }}
      >
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            display: "flex", // Ensures the table fills the remaining space
            flexDirection: "column",
            height: "100%", // Fill remaining height
            width: "100%", // Fill remaining width
          }}
        >
          <DrawerHeader />
          <CustomSeparator pageName="membership" />
          {contextHolder}
          <Typography
            gutterBottom
            variant="h4"
            sx={{ color: "text.secondary" }}
          >
            Corporate Membership Directory
          </Typography>

          <Stack spacing={2} direction="row" sx={{ mb: 3 }}>
            <CheckboxList
              baseColumns={baseColumns}
              checkedColumns={checkedColumns}
              onChange={onChange}
            />

            <CorporateMembershipListExcel />
            {/** added by delon on 2025-07-30 */}
            {
              pendingRegistrationsCount.corporate > 0 ?
              <div className='notification-lbl'>
                <NotificationsIcon />
                There' {pendingRegistrationsCount.corporate > 1 ? 're' : 's'} {pendingRegistrationsCount.corporate + ' pending registration' + (pendingRegistrationsCount.corporate > 1 ? 's': '')}
              </div>
              :
              null
            }
          </Stack>

          <Box
            sx={{
              flexGrow: 1, // Ensures the table box expands
              backgroundColor: "#fff", // Set the background color for the table container
              height: "100%", // Ensures the table fills available height
              width: "100%", // Ensures the table fills available width
              overflow: "auto", // Allow scrolling if needed
              borderRadius: "8px", // Optional: for rounded corners
            }}
          >
            <Form form={form} component={false}>
              <Table
                className={`${styles.customTable} corporate-membership-table`}
                components={{
                  body: { cell: EditableCell },
                }}
                bordered
                columns={mergedColumns}
                expandable={{
                  expandedRowRender,
                  defaultExpandedRowKeys: [""],
                  // onExpand: handleExpand,
                }}
                dataSource={rows}
                rowKey="membership_registrationID"
                scroll={{ x: "max-content", y: 200 * 5 }}
              />
            </Form>
          </Box>
        </Box>
      </Box>

      <Modal
        title="Membership Number"
        open={isModalMemberIDOpen}
        onCancel={() => {
          setIsModalMemberIDOpen(false);
          form.resetFields();
        }}
        footer={[
          <Buttons
            key="cancel"
            onClick={() => {
              setIsModalMemberIDOpen(false);
              form.resetFields();
            }}
          >
            Cancel
          </Buttons>,
          <Buttons key="submit" type="primary" onClick={() => form.submit()}>
            Submit
          </Buttons>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={() => handleApprove(userID)}
        >
          <Form.Item
            label="Membership Number"
            name="membershipNumber"
            rules={[
              { required: true, message: "Membership number is required!" },
            ]}
          >
            <Input
              placeholder="Input membership number"
              onChange={(e) => setMembershipNumber(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            label="Amount Paid"
            name="amountPaid"
            rules={[{ required: true, message: "Amount Paid is required!" }]}
          >
            <Input
              placeholder="Input amount paid"
              onChange={(e) => setPaymentAmount(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            label="Reference"
            name="payment_reference"
            rules={[{ required: false }]}
          >
            <Input
              placeholder="Payment reference"
              onChange={(e) => setPaymentReference(e.target.value)}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Payment Amount"
        open={isModalPaymentOpen}
        onCancel={() => {
          setIsModalPaymentOpen(false);
          form.resetFields();
        }}
        footer={[
          <Buttons
            key="cancel"
            onClick={() => {
              setIsModalPaymentOpen(false);
              form.resetFields();
            }}
          >
            Cancel
          </Buttons>,
          <Buttons key="submit" type="primary" onClick={() => form.submit()}>
            Submit
          </Buttons>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={() => handleActivateMembership(userID)}
        >
          <Form.Item
            label="Amount Paid"
            name="amountPaid"
            rules={[{ required: true, message: "Amount Paid is required!" }]}
          >
            <Input
              placeholder="Input amount paid"
              onChange={(e) => setPaymentAmount(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            label="Reference"
            name="payment_reference"
            rules={[{ required: false }]}
          >
            <Input
              placeholder="Payment reference"
              onChange={(e) => setPaymentReference(e.target.value)}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default CorporateMembership;
